export default "__VITE_ASSET__30396b5b__"